import { useSnapshot } from 'valtio';
import { AppStore } from '../store/store';
import { useStoreActions } from '../store/actions';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import cls from '../styles/Apartments.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

interface Type {
  [x: string]: {
    rooms: string;
    square: string;
  };
}

const apartments: Type = {
  '1': {
    rooms: '2',
    square: '69.9'
  },
  '2': {
    rooms: '1',
    square: '47.4'
  },
  '3': {
    rooms: '1',
    square: '48.9'
  },
  '4': {
    rooms: '2',
    square: '76.8'
  },
  '5': {
    rooms: '1',
    square: '42.4'
  },
  '6': {
    rooms: '1',
    square: '41.7'
  },
  '7': {
    rooms: '3',
    square: '95.3'
  },
  '8': {
    rooms: '2',
    square: '75.9'
  },
  '9': {
    rooms: '1',
    square: '45.3'
  },
  '10': {
    rooms: '1',
    square: '46.5'
  },
  '11': {
    rooms: '2',
    square: '69.8'
  },
  '12': {
    rooms: '3',
    square: '82.3'
  },
  '13': {
    rooms: '1',
    square: '48.9'
  },
  '14': {
    rooms: '2',
    square: '69.4'
  },
  '15': {
    rooms: '1',
    square: '49.7'
  },
  '16': {
    rooms: '2',
    square: '71.4'
  },
};

const ApartmentsM = () => {
  const {
    incrementSelectedFloor,
    decrementSelectedFloor,
    toggleSelectedObject,
    onHoverOverApartment,
    goPrevPage,
  } = useStoreActions();

  const { selectedFloor, selectedObject, selectedApartment } = useSnapshot(AppStore);

  return (
    <div className={cls.mainContainer}>
      <div onClick={() => goPrevPage(21)} className={cls.navigationButton}>
        <img src="./images/arrow.png" alt="" />
        <p>К выбору этажа</p>
      </div>

      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button onClick={decrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Этаж</p>
              <p>{selectedFloor}</p>
            </div>
            <button onClick={() => incrementSelectedFloor(14)} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>

          <div className={cls.selectionBody}>
            <button onClick={toggleSelectedObject} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Блок</p>
              <p>{selectedObject}</p>
            </div>
            <button onClick={toggleSelectedObject} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.imageWrapper}>
            <LazyLoadImage
              src={`./images/apartments/blockM/${selectedApartment}.png`}
              alt=""
              effect="blur"
            />
          </div>

          <div className={cls.textWrapper}>
            <p>{apartments[selectedApartment].rooms}-комнатные</p>

            <div className={cls.detailItem}>
              <div>Объект:</div>
              <div>«Seven»</div>
            </div>

            <div className={cls.detailItem}>
              <div>Площадь квартиры:</div>
              <div>{apartments[selectedApartment].square} кв.м</div>
            </div>

            <div className={cls.detailItem}>
              <div>Адрес:</div>
              <div>Бишкек, мкрн Асанбай</div>
            </div>
          </div>
        </div>
      </div>

      <div className={cls.imageContainer}>
        <div className={cls.imageBody}>
          <svg viewBox="0 0 1180 837.33331">
            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m2-5">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(1)}
                d="M 43.504871,424.37169V 299.59398 H 62.59602v 2.16728 h 58.64393v -16.31831 h 43.09054v 93.57531 h 34.29395v 28.30207 h -31.10678v 1.9123 h -22.43768v 11.21884 H 89.368248v 3.92022 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m1-6">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(2)}
                d="m 211.65996,281.80958h 49.87921 v 124.29963h -28.42955 v 1.01989h -30.34186 v -35.05887h -34.03898 v -90.26065 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m1-2">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(3)}
                d="m 266.00062,287.59077h 49.97542  v 13.85177h 40.15834  V 424.5012H 298.2957  v -18.57024h -32.29508  z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m2-4">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(4)}
                d="M 448.30734,321.84043V 428.19721  H 424.5012v 41.08171  h -21.26045v 82.14895  h -42.38318v -83.47592  h -2.25367v -82.98012  h 2.25367v -83.3407  h 87.44977z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m1-5">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(5)}
                d="m 449.90092,297.29922v -15.48964 h 87.10346v 112.22025 h -15.74272v 1.94418 h -33.79294v -2.59599 h -35.11367 v -96.0788z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m1-4">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(6)}
                d="m 541.6244,325.02422v -43.22538 h 86.56345v 15.55032 h -2.92977V 398.58749 H 563.82305V 366.67204 H 541.6244Z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m3-2">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(7)}
                d="m 629.51389,399.14524v -98.46065 h 88.02964v 251.7954 H 628.18785V 438.25182 h 20.13035v -39.10658 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m2-2">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(8)}
                d="M 722.34617,370.08635V 300.7522 h 87.35223v 103.35329 h -14.35588v 31.68659 h -9.33019v 28.26102 h -20.68869 v 88.44526h -42.97747 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m1-3">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(9)}
                d="m 813.9353,368.06931v -70.77009 h -2.67304v -15.41023 h 88.69895v 15.50585 h -1.62546v 104.73041 h -15.47371 v 2.03978h -32.87566 v -2.83658H 813.9353 Z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m1-1">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(10)}
                d="M 902.79749,409.19878V 284.933 h 93.14416v 87.0577 h -33.7149v 34.66143 h -30.6499v 2.54665 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m2-1">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(11)}
                d="m 966.01531,383.54404 v -3.31465 h 34.24609 v -95.65854 h 42.9397 v 16.97014 h 58.6673 v -1.96294 h 18.5494 v 50.43937 h 0.8955 v 74.3224 H 1019.1295 V 409.4398 h -22.5333 v -2.01015 h -30.58089 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m3-1">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(12)}
                d="m 962.993,552.58851v -82.8787 h 18.59277V 445.9807 h 37.59123v -13.56912 h 55.3136v -3.89657 h 46.7551v 124.76087 h -30.2443v 3.29035 h -47.9044v 17.25187 h -45.13031v -21.22959 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m1-2">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(13)}
                d="m 768.56893,568.10502v -97.49374 h 21.46678v -31.0105 h 74.51604v 32.35536 h -7.87231v 96.14888 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m2-3">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(14)}
                d="m 407.59868,522.78373v -49.83957 h 21.13943v -40.46497 h 74.4523v 37.24593 h 33.46528v 85.93965 h 2.73758v 15.30241 H 407.59868Z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m1-7">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(15)}
                d="m 263.61083,571.14087v -15.51554 h 4.78076v -87.68502 h -2.48599v -20.90242 h 32.52532v -18.34487 h 56.33298v 48.17136 h 1.37048v 74.92407 h -40.07976v 19.35242 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/m2-6">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(16)}
                d="m 43.247919,428.76063h 46.439046 v 3.92958h 55.775475 v 9.62525h 22.7564 v 2.74097h 39.26593 v 26.90705h -42.02035 v 96.40455H 121.26996 V 551.33772H 62.59602 v 1.89126h -18.3581 v -50.26167 h -0.990001 z"
              />
            </a>
          </svg>

          <LazyLoadImage
            src="./images/floors/blockM.png"
            alt=""
            effect="blur"
            placeholderSrc='./images/placeholder/floorM.png'
          />
        </div>

        <div onClick={() => goPrevPage(21)} className={cls.navigationButton1}>
          <img src="./images/arrow.png" alt="" />
          <p>К выбору этажа</p>
        </div>
      </div>
    </div >
  );
};

export default ApartmentsM;
